<form [formGroup]="formGroup">
    <p-treeSelect #treeSelect
    [panelClass]="styleClass()"
    [containerStyleClass]="styleClass()"
    [options]="filteredOptions"
    [placeholder]="setPreselectedTenant() ? 'Select...' : 'All'"
    [selectionMode]="selectionMode()"
    [filter]="true" 
    [filterInputAutoFocus]="true"
    formControlName="selectedTenants"
    (onNodeSelect)="onNodeSelect($event)"
    (onNodeUnselect)="onNodeUnselect($event)"
    [class]="class()"
    appendTo="body" />
</form>